import React, { useState, useEffect } from "react";
import "./HomePage.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer"
import bannerImage from "../assets/banner.png";
import secondaryImage from "../assets/secondbanner.gif";
import third from "../assets/third.mp4";
import image from "../assets/9.png"
import image3 from "../assets/6.png"
import image4 from "../assets/4.jpeg"
import image1 from "../assets/1.PNG"
import image5 from "../assets/2.PNG"
import image6 from "../assets/3.PNG"

import image2 from "../assets/image2.PNG"
import { FaFire, FaDollarSign, FaOilCan, FaBitcoin } from "react-icons/fa";

const HomePage = () => {
    const [activeTab, setActiveTab] = useState("fire");

    useEffect(() => {
        const loadTradingViewScript = (containerId, symbol) => {
            const container = document.getElementById(containerId);
            if (!container) {
                console.error(`Container with ID '${containerId}' not found.`);
                return; // Prevent further execution if element is missing
            }

            // Remove existing script if it exists
            const existingScript = container.querySelector("script");
            if (existingScript) {
                container.removeChild(existingScript);
            }

            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
            script.async = true;
            script.innerHTML = JSON.stringify({
                symbol: symbol,
                width: 320,
                height: 220,
                locale: "en",
                dateRange: "12M",
                colorTheme: "light",
                isTransparent: false,
                autosize: false,
                largeChartUrl: "",
            });

            container.appendChild(script);
        };


        const timer = setTimeout(() => {
            if (activeTab === "fire") {
                loadTradingViewScript("tradingview-widget-fire-1", "FX:EURUSD");
                loadTradingViewScript("tradingview-widget-fire-2", "FX:GBPUSD");
                loadTradingViewScript("tradingview-widget-fire-3", "FX:EURUSD");
                loadTradingViewScript("tradingview-widget-fire-4", "FX:EURUSD");
            } else if (activeTab === "dollar") {
                loadTradingViewScript("tradingview-widget-dollar-1", "FX:USDJPY");
                loadTradingViewScript("tradingview-widget-dollar-2", "FX:AUDUSD");
                loadTradingViewScript("tradingview-widget-dollar-3", "FX:GBPUSD");
                loadTradingViewScript("tradingview-widget-dollar-4", "FX:GBPUSD");
            } else if (activeTab === "oil") {
                loadTradingViewScript("tradingview-widget-oil-1", "TVC:USOIL");
                loadTradingViewScript("tradingview-widget-oil-2", "TVC:BRENT");
                loadTradingViewScript("tradingview-widget-oil-3", "FX:GBPUSD");
                loadTradingViewScript("tradingview-widget-oil-4", "FX:GBPUSD");
            } else if (activeTab === "bitcoin") {
                loadTradingViewScript("tradingview-widget-bitcoin-1", "CRYPTO:BTCUSD");
                loadTradingViewScript("tradingview-widget-bitcoin-2", "CRYPTO:ETHUSD");
                loadTradingViewScript("tradingview-widget-bitcoin-3", "FX:GBPUSD");
                loadTradingViewScript("tradingview-widget-bitcoin-4", "FX:GBPUSD");
            }
        }, 500); // Delay ensures the elements exist

        return () => clearTimeout(timer);
    }, [activeTab]);

    return (
        <>
            <Navbar />
            <div className="hero-section">
                <img src={secondaryImage} alt="Secondary" className="secondary-bg" />
                <img src={bannerImage} alt="Banner" className="hero-bg" />
                <div className="hero-content">
                    <h1>
                        Trading for Anyone. <br /> Anywhere. Anytime.
                    </h1>
                    <p>
                        Trade with the world’s largest retail broker <br /> and benefit from better-than-market conditions.
                    </p>
                    <div className="hero-buttons">
                        <a className="btn primary" href="https://cabinet.globustrading.co/login">
                            Start Trading Now ➜
                        </a>
                        <a className="btn secondary" href="https://cabinet.globustrading.co/register">
                            Create Account ➜
                        </a>

                    </div>
                </div>
            </div>
            {/* New section below hero */}
            <div className="below-hero-section">
                <h2>Excel in the Gold & Oil Markets with Confidence</h2>
                <p>
                    Trading conditions are key to your strategy’s success—choose only the best to excel.
                </p>
                <video className="below-video" autoPlay muted loop>
                    <source src={third} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            <div className="below-hero-section">
                <h2>Trade a wide range of assets from global markets</h2>
                <p>
                    Seize every opportunity with the world’s most traded assets
                </p>
            </div>

            <div className="tabs-section">
                <div className="tabs">
                    <button className={activeTab === "fire" ? "active" : ""} onClick={() => setActiveTab("fire")}>
                        <FaFire /> Most Popular
                    </button>
                    <button className={activeTab === "dollar" ? "active" : ""} onClick={() => setActiveTab("dollar")}>
                        <FaDollarSign /> Forex
                    </button>
                    <button className={activeTab === "oil" ? "active" : ""} onClick={() => setActiveTab("oil")}>
                        <FaOilCan /> Commodities
                    </button>
                    <button className={activeTab === "bitcoin" ? "active" : ""} onClick={() => setActiveTab("bitcoin")}>
                        <FaBitcoin /> Currency
                    </button>
                </div>

                <div className="tab-content">
                    {["fire", "dollar", "oil", "bitcoin"].map((tab) => (
                        activeTab === tab && (
                            <div className="tab-boxes" key={tab}>
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div className={`box-${index + 1}`} key={index}>
                                        <div id={`tradingview-widget-${tab}-${index + 1}`} className="tradingview-widget-container"></div>
                                    </div>
                                ))}
                            </div>
                        )
                    ))}
                </div>
            </div>

            <div className="below-hero-section">
                <h2>Why choose Us</h2>
                <p>
                    Choose us for unmatched reliability, speed, and access to global market opportunities
                </p>
            </div>

            <div className="two-column-section">
                <div className="column-left">
                    <img src={image} alt="Forex Trading" className="trading-image" />
                </div>
                <div className="column-right">
                    <h2>Buy 100+ Forex assets fast <br></br>& secure</h2>
                    <p>
                        Choose us for our unmatched reliability, lightning-fast execution, and competitive trading
                        conditions. With access to global markets and a wide range of assets, we provide the tools
                        and support you need to succeed. Experience trading at its best with us.
                    </p>
                    <a className="btn secondary" href="https://cabinet.globustrading.co/register">
                        Create Account ➜
                    </a>
                </div>
            </div>

            <div className="below-hero-section">
                <h2>Trade Smarter</h2>
                <p>
                    Create your account now and start trading with ease and confidence
                </p>
            </div>
            <div className="centered-image-container2">
                <div className="image-column">
                    <a href="https://cabinet.globustrading.co/register">
                        <img src={image1} alt="Trading Market 1" className="centered-image2" />
                    </a>
                </div>
                <div className="image-column">
                    <a href="https://cabinet.globustrading.co/register">
                        <img src={image5} alt="Trading Market 2" className="centered-image2" />
                    </a>
                </div>
                <div className="image-column">
                    <a href="https://cabinet.globustrading.co/register">
                        <img src={image6} alt="Trading Market 3" className="centered-image2" />
                    </a>
                </div>
            </div>


            <div className="two-column-section2">
                <div className="column-right2">
                    <h2>Join Globus Trading Today and Transform Your Forex Trading Experience</h2>
                    <p>
                        Become a trader with Globus Trading and elevate your forex trading to new heights.
                        Our platform offers cutting-edge technology, expert insights, and unparalleled support to help you succeed in the dynamic world of forex.
                    </p>
                    <a className="btn secondary" href="https://cabinet.globustrading.co/register">
                        Create Account ➜
                    </a>
                </div>
                <div className="column-left2">
                    <img src={image3} alt="Forex Trading" className="trading-image2" />

                </div>
            </div>


            <div className="below-hero-section">
                <h2> -------- WE ACCEPT -------- </h2>

            </div>
            <div className="centered-image-container2">
                <a href="">
                    <img src={image4} alt="Trading Market" className="centered-image2" /></a>
            </div>
            <br></br>
            <br></br>

            <Footer />
        </>
    );
};

export default HomePage;
